__turbopack_context__.v({
  "modal": "TestModal-module-scss-module__SzCk0W__modal",
  "modalContent": "TestModal-module-scss-module__SzCk0W__modalContent",
  "modalDescription": "TestModal-module-scss-module__SzCk0W__modalDescription",
  "modalFooter": "TestModal-module-scss-module__SzCk0W__modalFooter",
  "modalOverlay": "TestModal-module-scss-module__SzCk0W__modalOverlay",
  "modalTitle": "TestModal-module-scss-module__SzCk0W__modalTitle",
});
